import api from '@/core/services/api.service'

const DoctorModule = {

  async getTreeSelect(patientId = null, date = null, includeDoctorId = null) {
    const params = []
    let result = []
    if (typeof patientId != 'undefined' && patientId)
      params.push(`patient_id=${encodeURIComponent(patientId)}`)
    if (date)
      params.push(`date=${encodeURIComponent(date)}`)
    if (includeDoctorId)
      params.push(`include_doctor_id=${encodeURIComponent(includeDoctorId)}`)
    const queryParams = params.length ? `?${params.join('&')}` : ''
    const response = await api.get(`doctors/treeselect${queryParams}`)
    if (response.status == 200)
      result = response.data.data
    return result
  }

}

export default DoctorModule
